import angular from 'angular';

/**
 * Controla la directiva para ver y añadir comenarios en las tareas.
 */
InputComentarioCtrl.$inject = ['$log', '$scope', '$http', '$timeout', '$filter', '$q', 'mentioUtil'];
export default function InputComentarioCtrl($log, $scope, $http, $timeout, $filter, $q, mentioUtil) {

    var vm = this;

    vm.puedeVerTareas = Sigo.user.puedeVerTareas;
    vm.id = 'comentarios-text-area' + vm.tareaId;
    for (let i = 0;i < 5; i++) vm.id += random();

    vm.searchUsuario = function (term) {

        if (typeof vm.urlSearch !== "undefined")
            $http.get(vm.urlSearch + '?search=' + term)
                .then((response) => {
                    vm.people = response.data;
                });
        else {
            let peopleList = [];
            angular.forEach(vm.usuariosParaCitar, (item) => {
                if (item.codusuario.toUpperCase().indexOf(term.toUpperCase()) >= 0) {
                    peopleList.push(item);
                }
            });
            vm.people = peopleList;
        }
    };

    vm.searchTarea = function (term) {
        let tareasList = [];

        return $http.get(Sigo.var.path + '/obras/search?term=' + term)
            .then((response) => {
                tareasList = response.data.data.obras;
                vm.tareas = tareasList;
                return $q.when(tareasList);
            });
    };

    vm.citarUsuario = function () {
        anyadirCaracterYSeleccionar('@', vm.mensaje);
    };
    vm.citarTarea = function () {
        anyadirCaracterYSeleccionar('#', vm.mensaje);
    };

    vm.getTareaTextRaw = function (tarea) {
        return '#' + tarea.codigo;
    };

    vm.getUsuarioTextRaw = function (item) {
        return '@' + item.code;
    };

    function anyadirCaracterYSeleccionar(caracter, mensaje) {

        let html = typeof mensaje !== 'undefined' ? mensaje.trim() : '';
        if (html.length > 0) html += ' ';
        html += caracter;

        $timeout(function () {
            let htmlContent = $scope["text-area"];
            if (htmlContent) {
                let ngHtmlContent = angular.element(htmlContent);
                ngHtmlContent.html(html);
                vm.mensaje = html;
                mentioUtil.selectElement(null, htmlContent, [0], html.length - 1);
            }
        }, 0);
    }

    function random() {
        return Math.floor((Math.random() * 6) + 1)
    }
}